import { XdrOverviewWebComponent } from './component/XdrOverviewWebComponent';
import { WEB_COMPONENT_XDR_OVERVIEW } from '../../webcomponents.constants';

export { XdrOverviewWebComponent };

window.customElements.define(WEB_COMPONENT_XDR_OVERVIEW, XdrOverviewWebComponent);
